<template>
  <div class="verify-page">
    <div class="verify-card">
      <div class="verify-emoji">✉️</div>
      <h2 v-if="state==='loading'">Verifying your email…</h2>
      <h2 v-else-if="state==='ok'">Email verified!</h2>
      <h2 v-else>Verification failed</h2>
      <p v-if="state==='loading'">Hang tight, this only takes a moment.</p>
      <p v-else>{{ message }}</p>
      <button class="verify-btn" @click="$router.push('/Login')" v-if="state!=='loading'">Continue to Login</button>
    </div>
  </div>
</template>

<script>
export default {
  data(){ return { state:'loading', message:'' }; },
  created(){
    var token = this.$route.query.token || '';
    if(!token){ this.state='err'; this.message='Missing verification token.'; return; }
    this.$http({ method:'get', url:'verify_email', data:{ token: token } }).then(res=>{
      if(res && res.code === 200){
        this.state = 'ok';
        this.message = res.msg || 'Your email has been verified successfully.';
      } else {
        this.state = 'err';
        this.message = (res && res.msg) || 'Verification failed.';
      }
    }).catch(()=>{ this.state='err'; this.message='Network error. Please try again.'; });
  }
};
</script>

<style scoped>
.verify-page { min-height:100vh; display:flex; align-items:center; justify-content:center; padding:24px; background:linear-gradient(135deg,#fff6fa 0%,#f5e8ff 100%); }
.verify-card { background:#fff; border-radius:18px; padding:32px 24px; max-width:420px; width:100%; text-align:center; box-shadow:0 20px 50px rgba(160,32,240,.12); }
.verify-emoji { font-size:48px; margin-bottom:8px; }
.verify-card h2 { color:#1a1033; margin:8px 0 6px; font-size:20px; }
.verify-card p { color:#6b5c85; font-size:14px; line-height:1.5; margin:0 0 22px; }
.verify-btn { background:linear-gradient(90deg,#ff4d8d,#a020f0); color:#fff; border:0; border-radius:999px; padding:12px 28px; font-weight:700; cursor:pointer; }
</style>
